import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { HeaderService } from '../../tools/header.service';
import { IxellAPIService, Reference } from '../../tools/api.service';
import { Model } from '../../entities/model';
import { Router } from '@angular/router';
import { SearchResult } from 'src/app/entities/searchResult';
import { SearchCrit } from 'src/app/entities/searchCrit';
import { StorageService } from 'src/app/tools/storage.service';

@Component({
    selector: 'globalColorwebtech',
    templateUrl: './globalColorwebtech.component.html',
    styleUrls: ['./globalColorwebtech.component.scss']
})

export class GlobalColorwebtechComponent implements OnInit, OnDestroy {

    colorCode: string;
    manufacturer: string;
    technology: string;
    reference: Reference;
    references: Reference[];
    variant: Reference;
    variants: Reference[];
    biTons: Reference[];
    searchResult: SearchResult;
    model: Model;
    title: string;
    logo: string;
    searchCrit: SearchCrit;
    dateMAJ: string;

    private biTonsSub: any;
    private titleSub: any;
    private logoSub: any;
    private canBackSub: any;
    private backSub: any;
    private majSub: any;

    constructor(private headerService: HeaderService, private apiService: IxellAPIService, private router: Router, private storage: StorageService) { }

    ngOnInit() {
        if (this.storage.get("colorCode") != null) {
            this.colorCode = this.storage.get("colorCode");
            this.storage.remove("colorCode");
        }

        if (this.storage.get("manufacturer") != null) {
            this.manufacturer = this.storage.get("manufacturer");
            if (this.manufacturer.toLowerCase() == "dacia" || this.manufacturer.toLowerCase() == "alpine")
                this.manufacturer = "";
            else
                this.storage.remove("manufacturer");
        }

        if (this.storage.get("technology") != null) {
            this.technology = this.storage.get("technology");
            this.storage.remove("technology");
        }

        ///*----------------------------------------------------------------------------------------------------*/console.log("0 - before getBddMajDate : ");
        ///*----------------------------------------------------------------------------------------------------*/console.log(new Date().toLocaleString());

        this.majSub = this.apiService.getBddMajDate().subscribe(date => {

            ///*----------------------------------------------------------------------------------------------------*/console.log("4 - end call getBddMajDate : ");
            ///*----------------------------------------------------------------------------------------------------*/console.log(new Date().toLocaleString());

            this.dateMAJ = date;
            if (this.majSub != null) this.majSub.unsubscribe();
        },
        error => {
            if (this.majSub != null) this.majSub.unsubscribe();
        });

        ///*----------------------------------------------------------------------------------------------------*/console.log("0 - after getBddMajDate : ");
        ///*----------------------------------------------------------------------------------------------------*/console.log(new Date().toLocaleString());

        this.backSub = this.headerService.currentBack.subscribe(back => {

            ///*----------------------------------------------------------------------------------------------------*/console.log("ColorWebTech back");
            ///*----------------------------------------------------------------------------------------------------*/console.log(back);


            if (back) {
                if (this.searchCrit != null && this.searchCrit.manufacturer != null)
                    if (this.searchCrit.manufacturer != null && this.searchCrit.manufacturer != "" && this.searchCrit.manufacturer.toLowerCase() != "dacia" && this.searchCrit.manufacturer.toLowerCase() != "alpine")
                        this.storage.set("manufacturer", this.searchCrit.manufacturer);
                if (this.reference != null) {
                    this.reference = null
                    if (this.biTons) {
                        if (this.biTons.length == 1) {
                            this.biTons = null
                            if (this.variants.length == 1) {
                                this.variants = null;
                                this.headerService.changeTitle("ColorWebTech");
                                if (this.references.length == 1) {
                                    this.references = null;
                                    if (this.storage.get("previous") == "colorbook") {
                                        this.router.navigate(["/colorbook"]);
                                        this.storage.remove("previous");
                                        this.headerService.changeLogo("");
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if (this.variants.length == 1) {
                            this.variants = null;
                            this.headerService.changeTitle("ColorWebTech");

                            this.headerService.changeLogo(null);
                            if (this.references.length == 1) {
                                this.references = null;
                                if (this.storage.get("previous") == "colorbook") {
                                    this.router.navigate(["/colorbook"]);
                                    this.storage.remove("previous");
                                    this.headerService.changeLogo("");
                                }
                            }
                        }
                    }
                }
                else {
                    if (this.biTons != null) {
                        this.biTons = null
                        this.headerService.changeTitle("ColorWebTech");
                        this.headerService.changeLogo(null);
                        if (this.variants != null) {
                            this.variants = null;
                            if (this.references.length == 1) {
                                this.references = null;
                                if (this.storage.get("previous") == "colorbook") {
                                    this.router.navigate(["/colorbook"]);
                                    this.storage.remove("previous");
                                }
                            }
                            this.headerService.changeLogo(null);
                        }
                    }
                    else {
                        if (this.variants != null) {
                            this.variants = null;
                            if (this.references.length == 1) {
                                this.references = null;
                                if (this.storage.get("previous") == "colorbook") {
                                    this.router.navigate(["/colorbook"]);
                                    this.storage.remove("previous");
                                    this.headerService.changeLogo("");
                                }
                            }
                            this.headerService.changeLogo(null);
                            this.headerService.changeTitle("ColorWebTech");
                        }
                        else {
                            if (this.references != null) {
                                this.references = null;
                                if (this.storage.get("previous") == "colorbook") {
                                    this.router.navigate(["/colorbook"]);
                                    this.storage.remove("previous");
                                    this.headerService.changeLogo(null);
                                }
                            }
                            else {
                                if (this.storage.get("previous") == "colorbook") {
                                    this.router.navigate(["/colorbook"]);
                                }
                                else {
                                    this.headerService.changeTitle("IxellWebLab");
                                    this.headerService.changeCanBack(false);
                                    this.router.navigateByUrl("/home");
                                    this.storage.remove("manufacturer");
                                }
                                this.storage.remove("previous");
                                this.headerService.changeLogo(null);

                            }
                        }
                    }
                }
                this.headerService.changeBack(false);
            }
        });
        this.headerService.changeCanBack(true);
        this.headerService.changeTitle("ColorWebTech");
    }

    ngOnDestroy(): void {
        if (this.canBackSub != null) this.canBackSub.unsubscribe();
        if (this.backSub != null) this.backSub.unsubscribe();
        if (this.majSub != null) this.majSub.unsubscribe();
    }

    search(event: any) {
        this.references = event.ref;
        this.searchCrit = event.crit;

        if (this.colorCode) {
            this.searchCrit.colorCode = this.colorCode;
            this.colorCode = null;
        }
        if (this.manufacturer) {
            this.searchCrit.manufacturer = this.manufacturer;
            this.manufacturer = null;
        }

        if (this.technology) {
            this.searchCrit.technology = this.technology;
            this.technology = null;
        }
    }

    selectRef(event: any) {

        console.log(event);

        if (event.biTon == false)
            this.reference = event;
        else {
            this.biTonsSub = this.apiService.getBiTons(event.tident, this.searchCrit.searchWorld, this.searchCrit.technology).subscribe(data => {
                this.biTons = data;
                if (this.biTonsSub != null) this.biTonsSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    if (this.biTonsSub != null) this.biTonsSub.unsubscribe();
                });
        }
    }

    checkVariants(event: any) {
        this.variants = event;
        this.headerService.changeTitle(this.variants[0].designation);
        this.headerService.changeLogo(this.variants[0].logoName.replace('.BMP', '.png'));
    }

    selectModel(event: any) {
        this.model = event;
    }
    

}
